import { Component, computed, forwardRef, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  UntypedFormControl,
} from '@angular/forms';

export interface SegmentMenuButton {
  value: string;
  displayValue: string;
}

type ButtonInput = string | SegmentMenuButton;

export const DEFAULT_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SegmentButtonsComponent),
  multi: true,
};

@Component({
  selector: 'atx-segment-buttons',
  templateUrl: './segment-buttons.component.html',
  styleUrl: './segment-buttons.component.scss',
  providers: [DEFAULT_VALUE_ACCESSOR],
  imports: [CommonModule, ReactiveFormsModule],
})
export class SegmentButtonsComponent implements ControlValueAccessor {
  public buttons = input<ButtonInput[]>([]);

  /**
   * Normalized buttons to always be { value, displayValue }
   */
  public buttonValues = computed(() => {
    return this.buttons()?.map((btn) =>
      typeof btn === 'string'
        ? { value: btn.toLowerCase(), displayValue: btn }
        : { value: btn.value.toLowerCase(), displayValue: btn.displayValue },
    );
  });

  public inputControl = new UntypedFormControl();

  public setValue(value: string) {
    const normalizedValue = value.toLowerCase();
    this.onChange(normalizedValue);
    this.onTouch(normalizedValue);
    this.inputControl.setValue(normalizedValue);
  }

  // ControlValueAccessor methods
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onChange: (arg: string) => void = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onTouch: (arg: string) => void = () => {};

  public writeValue(value: string | undefined): void {
    if (!value) return;
    this.inputControl.setValue(value.toLowerCase());
  }

  public registerOnChange(fn: (arg: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: (arg: string) => void): void {
    this.onTouch = fn;
  }
}
